<template>
  <div class="master-tree-transfer">
    <div v-if="isDev" style="font-size: 11px; color: #bbb;">
      <div>isNewDoc: {{ isNewDoc }}</div>
      <div>props.addSectionsData: {{ addSectionsData.length }}</div>
      <div>filteredMasterSectionData: {{ filteredMasterSectionData.length }}</div>
      <div>addSectionsIds: {{ addSectionsIds.length }}</div>
      <div>addSectionsDataBySectionId: {{ Object.keys(addSectionsDataBySectionId).length }}</div>
      <!-- addSectionsDataBySectionId: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(addSectionsDataBySectionId, null, 2)}}</pre> -->
    </div>

    <div v-if="isDev">
      <!-- addSectionsDataBySectionId: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(addSectionsDataBySectionId, null, 2)}}</pre> -->
      <!-- addSectionsData: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(addSectionsData, null, 2)}}</pre>
      removeTreeData: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{JSON.stringify(removeTreeData, null, 2)}}</pre> -->
    </div>

    <AntAlert
      v-if="noApiSection"
      type="error"
      message="Please add at least one API section"
      showIcon
    />

    <AntAlert
      v-if="!!shouldBeAddedSections.length"
      class="section-alert"
      type="warning"
      showIcon
    >
      <template #message>
        因 Added Sections 的內容中有使用到以下 Section 的超連結，請將連結移除，或是將以下 Section 加回 <AddIcon class="icon added-sections-icon" /><b> Added Sections</b>。
        <ul class="section-list">
          <li v-for="{ sectionId, enTitle, cnTitle, remark = '', linkUsedSections } in shouldBeAddedSections" :key="sectionId">
            <AntPopover :title="`使用到「${enTitle} ${cnTitle} ${remark}」連結的區塊：`" placement="right">
              <span v-if="isDev" style="color:BurlyWood;">{{ sectionId }} </span> {{ enTitle }} {{ cnTitle }} {{ remark }}
              <template #content>
                <ul class="section-list" style="max-height: 300px; overflow-y: auto;">
                  <li v-for="linkUsedSection in linkUsedSections" :key="linkUsedSection.sectionId">
                    <span v-if="isDev" style="color:BurlyWood;">{{ linkUsedSection.sectionId }} </span> {{ linkUsedSection.enTitle }} {{ linkUsedSection.cnTitle }} {{ linkUsedSection.remark }}
                  </li>
                </ul>
              </template>
            </AntPopover>
          </li>
        </ul>
      </template>
    </AntAlert>

    <AntAlert
      v-if="!!shouldBeRemovedSections.length"
      class="section-alert"
      type="warning"
      showIcon
    >
      <template #message>
        因以下 Section 的表格未包含此子本所選 Platforms，建議將其加入 <DeleteIcon class="icon removed-sections-icon" /> <b>Removed Sections</b> 中，否則前台顯示的表格將為空。
        <ul class="section-list">
          <li v-for="{ sectionId, enTitle, cnTitle, remark = '' } in shouldBeRemovedSections" :key="sectionId">
            <span v-if="isDev" style="color:BurlyWood;">{{ sectionId }} </span> {{ enTitle }} {{ cnTitle }} {{ remark }}
          </li>
        </ul>
      </template>
    </AntAlert>

    <AntRow :gutter="16">
      <AntCol :span="12">
        <div style="display: flex; align-items: center; gap: 8px;">
          <AddIcon class="icon added-sections-icon" />
          <b>Added Sections</b>
        </div>
        <AntInputSearch
          v-model:value="searchState.add.value"
          placeholder="Search"
          style="margin: 8px 0"
          allowClear
          @search="onSearch('add')"
        />
        <AntTree
          v-model:expandedKeys="addExpandedKeys"
          v-model:selectedKeys="addSelectedKeys"
          class="transfer-tree"
          :treeData="displayedAddTreeData"
          :fieldNames="{ key: 'sectionId', title: 'treeTitleWithRemark', children: 'treeChildren' }"
          defaultExpandAll
          @select="onSelectAdd"
        >
          <template #title="{ dataRef, treeTitleWithRemark }">
            <span
              v-if="isDev"
              style="color:BurlyWood;"
            >{{ dataRef.sectionId }} </span> {{ treeTitleWithRemark }}
          </template>
        </AntTree>

        <div v-if="isDev">
          searchState: <pre style="font-size: 10px; max-height: 200px; overflow-y: auto;">{{ JSON.stringify(searchState, null, 2) }}</pre>
        </div>
      </AntCol>

      <AntCol :span="12">
        <div style="display: flex; align-items: center; gap: 8px;">
          <DeleteIcon class="icon removed-sections-icon" />
          <b>Removed Sections</b>
        </div>
        <AntInputSearch
          v-model:value="searchState.remove.value"
          placeholder="Search"
          style="margin: 8px 0"
          allowClear
          @search="onSearch('remove')"
        />
        <AntTree
          v-model:selectedKeys="removeSelectedKeys"
          class="transfer-tree"
          :treeData="displayedRemoveTreeData"
          :fieldNames="{ key: 'sectionId', title: 'treeTitleWithRemark', children: 'treeChildren' }"
          :expandedKeys="removedKeys"
          defaultExpandAll
          @select="onSelectRemove"
        >
          <template #title="{ dataRef, treeTitleWithRemark }">
            <span
              v-if="isDev"
              style="color:BurlyWood;"
            >{{ dataRef.sectionId }} </span> {{ treeTitleWithRemark }}
          </template>
        </AntTree>

        <div v-if="isDev">
          <div>removedKeys: {{ removedKeys }}</div>
          <div>halfRemovedParentKeysSet: {{ halfRemovedParentKeysSet }}</div>
          <div>addExpandedKeys: {{ addExpandedKeys }}</div>
        </div>
      </AntCol>
    </AntRow>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  inject,
  watch,
  computed,
  nextTick,
  toRaw,
} from 'vue'

import {
  Row as AntRow,
  Col as AntCol,
  Tree as AntTree,
  Input as AntInput,
  Alert as AntAlert,
  Popover as AntPopover,
} from 'ant-design-vue'

import AddIcon from '@ant-design/icons-vue/lib/icons/PlusCircleFilled'
import DeleteIcon from '@ant-design/icons-vue/lib/icons/MinusCircleFilled'

import { isEqual, cloneDeep } from 'lodash'
import { APPENDIX_SECTION_TAGS_WITH_PLATFORM, isRootParentSectionId } from '../lib/constants'

import {
  shouldDisplay,
  transformToNested,
  findTreeAndKeys,
  getLinkSectionIdMap,
} from '../lib/libsV3'

export default {
  name: 'MasterTreeTransfer',
  components: {
    AntRow,
    AntCol,
    AntTree,
    AntAlert,
    AntPopover,
    AntInputSearch: AntInput.Search,
    AddIcon,
    DeleteIcon,
  },
  props: {
    isNewDoc: {
      type: Boolean,
      default: false,
    },
    docData: Object,
    sectionsByWallet: Object,
    masterSectionData: Array,
    addSectionsData: {
      type: Array,
      default: () => [],
    },
    fieldsByWallet: Object,
  },
  emits: ['change'],
  setup(props, { emit, expose }) {
    const isDev = inject('isDev')

    const addSelectedKeys = ref([])
    const addExpandedKeys = ref([])
    const removeSelectedKeys = ref([])

    const removedKeysSet = ref(new Set())
    const halfRemovedParentKeysSet = ref(new Set())
    const removedKeys = computed(() => [...new Set([...removedKeysSet.value, ...halfRemovedParentKeysSet.value])])

    const addSectionsData = ref(props.addSectionsData)
    const addSectionsDataBySectionId = computed(() => Object.fromEntries(addSectionsData.value.map(d => [d.sectionId, d])))

    const addSectionsIds = computed(() => {
      console.log('[MasterTreeTransfer] computed addSectionsIds', props.docData.docId, {
        'props.addSectionsData.docId': props.addSectionsData[0]?.docId,
        'addSectionsData.value.docId': addSectionsData.value[0]?.docId,
        'props.addSectionsData': props.addSectionsData.length,
        'addSectionsData.value': addSectionsData.value.length,
      })
      return addSectionsData.value.map(section => section.sectionId).sort()
    })

    const filteredMasterSectionData = computed(() => {
      const {
        platforms: docPlatforms,
        excludedPlatforms: docExcludedPlatforms,
      } = props.docData

      console.log('[MasterTreeTransfer] computed filteredMasterSectionData', {
        docData: props.docData,
        masterSectionData: props.masterSectionData,
        docPlatforms,
        docExcludedPlatforms,
      })
      if (!docPlatforms?.length && !docExcludedPlatforms?.length) {
        console.log('[MasterTreeTransfer] computed filteredMasterSectionData return props.masterSectionData')
        return cloneDeep(props.masterSectionData)
      }
      const result = cloneDeep(props.masterSectionData).filter(section => shouldDisplay({ ...section, docs: null }, props.docData))

      console.log('[MasterTreeTransfer] computed filteredMasterSectionData result', result)
      return result
    })

    const computeRemovedKeys = () => {
      console.log('[MasterTreeTransfer] computeRemovedKeys', { addSectionsIds: addSectionsIds.value })
      const newRemovedKeysSet = new Set()

      const newHalfRemovedParentKeysSet = new Set()
      filteredMasterSectionData.value.forEach((section) => {
        if (!addSectionsIds.value.includes(section.sectionId)) {
          newRemovedKeysSet.add(section.sectionId)
          console.log(section.sectionId, section.parentSectionId)
          if (!isRootParentSectionId(section.parentSectionId) && !addSectionsIds.value.includes(section.parentSectionId)) {
            newRemovedKeysSet.add(section.parentSectionId)
          }
        }
      })
      console.log('newRemovedKeysSet', newRemovedKeysSet)

      filteredMasterSectionData.value.forEach((section) => {
        if (!isRootParentSectionId(section.parentSectionId)) {
          const siblings = filteredMasterSectionData.value.filter(s => s.parentSectionId === section.parentSectionId)

          // 检查兄弟节点是否部分被移除
          const removedSiblings = siblings.filter(s => newRemovedKeysSet.has(s.sectionId))

          // console.log(section.sectionId, section.cnTitle, '[MasterTreeTransfer] siblings', siblings)
          // console.log(section.sectionId, section.cnTitle, '[MasterTreeTransfer] removedSiblings', removedSiblings)
          if (removedSiblings.length > 0 && addSectionsIds.value.includes(section.parentSectionId)) {
            // console.log(2222, section.enTitle, section.cnTitle, 'section.parentSectionId', section.parentSectionId)
            // console.log(2222, 'removedSiblings.length', removedSiblings.length, 'siblings.length', siblings.length, siblings)
            newHalfRemovedParentKeysSet.add(section.parentSectionId)
          }
          // else if (!removedSiblings.length) {
          //   if (section.parentSectionId) {
          //     console.log(2222)
          //     newRemovedKeysSet.delete(section.parentSectionId)
          //     newHalfRemovedParentKeysSet.delete(section.parentSectionId)
          //   } else {
          //     console.log(3333)
          //     newRemovedKeysSet.delete(section.sectionId)
          //   }
          // }
          // else if (removedSiblings.length === siblings.length) {
          //   newRemovedKeysSet.delete(section.parentSectionId)
          //   newHalfRemovedParentKeysSet.delete(section.parentSectionId)
          // }
        }
      })
      console.log('newRemovedKeysSet', newRemovedKeysSet)
      console.log('newHalfRemovedParentKeysSet', newHalfRemovedParentKeysSet)
      removedKeysSet.value = newRemovedKeysSet
      halfRemovedParentKeysSet.value = newHalfRemovedParentKeysSet
    }

    const searchState = reactive({ add: {}, remove: {} })

    const derivedSectionsData = computed(() => {
      if (!filteredMasterSectionData.value.length) return { addSectionsData: [], removeSectionData: [] }

      const newAddSectionsData = []
      const removeSectionData = filteredMasterSectionData.value.filter((section) => {
        const { sectionId } = section
        const sectionWithDoc = {
          ...section,
          docId: props.docData.docId, // ex: filteredMasterSectionData.docId = multi#master，轉為子本 docId
        }

        const isInHalfRemovedParentKeysSet = halfRemovedParentKeysSet.value.has(sectionId)
        if (isInHalfRemovedParentKeysSet) {
          newAddSectionsData.push({
            ...(addSectionsDataBySectionId.value[sectionId] || sectionWithDoc),
            docId: props.docData.docId, // 只在 treeData 派生時改為目前子本 docId
          })
        }
        if (removedKeysSet.value.has(sectionId) || halfRemovedParentKeysSet.value.has(sectionId)) return true

        newAddSectionsData.push({
          ...(addSectionsDataBySectionId.value[sectionId] || sectionWithDoc),
          docId: props.docData.docId, // 只在 treeData 派生時改為目前子本 docId
        })
        return false
      })

      return { addSectionsData: newAddSectionsData, removeSectionData }
    })

    const addTreeData = computed(() => transformToNested({
      data: derivedSectionsData.value.addSectionsData,
      showNo: true,
      useSortOrderForNumbering: true,
    }))

    const removeTreeData = computed(() => transformToNested({
      data: derivedSectionsData.value.removeSectionData,
      showNo: true,
      useSortOrderForNumbering: true,
    }))

    const displayedAddTreeData = computed(() => {
      if (!searchState.add.text) return addTreeData.value
      return findTreeAndKeys(addTreeData.value, searchState.add.text).nestedTree
    })

    const displayedRemoveTreeData = computed(() => {
      if (!searchState.remove.text) return removeTreeData.value
      return findTreeAndKeys(removeTreeData.value, searchState.remove.text).nestedTree
    })

    // watch(() => props.docData.docId, (newDocId) => {
    //   console.log('[MasterTreeTransfer] watch props.docData.docId', newDocId)
    //   if (!newDocId || !['single', 'multi'].some(wallet => newDocId.includes(wallet))) return // 防止 management docId = 'template' 觸發
    //   addSectionsData.value = addSectionsData.value.map(section => ({
    //     ...section,
    //     docId: newDocId,
    //   }))
    // })

    watch([
      // () => props.docData.wallet,
      // () => props.addSectionsData[0].docId,
      () => props.docData.platforms,
      () => props.docData.excludedPlatforms,
      () => props.masterSectionData,
    ], async ([newDocPlatforms, newDocExcludedPlatforms, newMasterSectionData], [oldDocPlatforms, oldDocExcludedPlatforms, oldMasterSectionData]) => {
      console.log('[MasterTreeTransfer] watch props.docData/platforms/excluded/masterSectionData', {
        'props.addSectionsData': props.addSectionsData.length,
        filteredMasterSectionData: filteredMasterSectionData.value.length,
        'props.addSectionsData.docId': props.addSectionsData[0].docId,
        newDocPlatforms,
        oldDocPlatforms,
        newDocExcludedPlatforms,
        oldDocExcludedPlatforms,
        newMasterSectionData: newMasterSectionData?.length,
        oldMasterSectionData: oldMasterSectionData?.length,
      })

      searchState.add = {}
      searchState.remove = {}
      addSelectedKeys.value = []
      removeSelectedKeys.value = []
      addSectionsData.value = cloneDeep(filteredMasterSectionData.value)
      computeRemovedKeys()
    }, { immediate: true })

    const noApiSection = computed(() => !addSectionsData.value.some(d => d.sectionType === 'api'))

    const linkSectionIdMap = computed(() => {
      const { wallet } = props.docData
      const fieldsData = Object.values(props.fieldsByWallet[wallet])
        .filter(({ sectionId }) => addSectionsIds.value.includes(sectionId))
        .flatMap(({ sectionFields }) => Object.values(sectionFields).flatMap(scope => Object.values(scope)))

      return getLinkSectionIdMap(addSectionsData.value, fieldsData)
    })

    const shouldBeAddedSections = computed(() => {
      const { wallet } = props.docData
      console.log('[MasterTreeTransfer] computed shouldBeAddedSections', { linkSectionIdMap: linkSectionIdMap.value, addSectionsIds: addSectionsIds.value })
      const result = Object.entries(linkSectionIdMap.value).reduce((acc, [linkSectionId, linkUsedSectionIdsSet]) => {
        if (!addSectionsIds.value.includes(linkSectionId)) {
          acc.push({
            ...props.sectionsByWallet[wallet][linkSectionId],
            linkUsedSections: [...linkUsedSectionIdsSet].map(sectionId => props.sectionsByWallet[wallet][sectionId] || {}),
          })
        }
        return acc
      }, [])

      console.log('[MasterTreeTransfer] computed shouldBeAddedSections', result)
      // if (props.isNewDoc && addSectionsData.value[0].wallet !== props.addSectionsData[0].wallet) return []
      return result
    })

    const shouldBeRemovedSections = computed(() => {
      console.log('[MasterTreeTransfer] computed shouldBeRemovedSections')
      const { platforms: docPlatforms = [], excludedPlatforms: docExcludedPlatforms = [] } = props.docData
      if (!docPlatforms?.length && !docExcludedPlatforms?.length) return []

      return addSectionsData.value.filter(({ tag, sectionId, wallet }) => {
        if (!APPENDIX_SECTION_TAGS_WITH_PLATFORM.includes(tag)) return false
        const rowData = Object.values(props.fieldsByWallet[wallet][sectionId].row)
        return rowData.every(row => !shouldDisplay(row, props.docData))
      })
    })

    expose({
      noApiSection,
      shouldBeAddedSections,
      shouldBeRemovedSections,
    })

    const onSearch = (type) => {
      searchState[type].text = searchState[type].value
      if (!searchState[type].value) return
      const treeData = type === 'add' ? addTreeData.value : removeTreeData.value
      const findResult = findTreeAndKeys(treeData, searchState[type].text)
      console.log(type, 'findResult', findResult)
      addExpandedKeys.value = [...new Set([...addExpandedKeys.value, ...findResult.keys])]
    }

    const onSelectAdd = ([selectedKey], { node }) => {
      console.log('[MasterTreeTransfer] onSelectAdd selectedKey', selectedKey, node)

      // if (node.parentSectionId) {
      //   const addedSiblingsSections = props.addSectionsData.filter(s => s.sectionId !== node.sectionId && s.parentSectionId === node.parentSectionId)
      //   if (!addedSiblingsSections.length) {
      //     console.log(11)

      //     emit('update:addSectionsData', props.addSectionsData.filter(s => s.sectionId !== node.sectionId && s.parentSectionId !== node.parentSectionId))
      //   } else {
      //     console.log(22)
      //     emit('update:addSectionsData', props.addSectionsData.filter(s => s.sectionId !== node.sectionId))
      //   }
      // }

      if (!selectedKey) {
        selectedKey = node.key // eslint-disable-line no-param-reassign
        addSelectedKeys.value = [node.key]
      }

      const newRemovedKeysSet = new Set(removedKeysSet.value)
      newRemovedKeysSet.add(selectedKey)
      if (!isRootParentSectionId(node.parentSectionId)) newRemovedKeysSet.add(node.parentSectionId)

      if (node.parent?.node?.treeChildren) {
        const { parent: { node: parentNode } } = node
        // parentNode.treeChildren 會隨著當前搜尋狀態變化，所以需要使用 addTreeData.value 來取得 treeChildren
        const treeChildren = addTreeData.value.find(d => d.sectionId === parentNode.sectionId)?.treeChildren || []
        const everyChildIsRemoved = treeChildren.every(({ sectionId }) => newRemovedKeysSet.has(sectionId))
        if (everyChildIsRemoved) {
          halfRemovedParentKeysSet.value.delete(parentNode.sectionId)
        } else {
          halfRemovedParentKeysSet.value.add(parentNode.sectionId)
        }
      }

      if (node.treeChildren) {
        node.treeChildren.forEach(c => newRemovedKeysSet.add(c.sectionId))
        halfRemovedParentKeysSet.value.delete(selectedKey)
      }

      removedKeysSet.value = newRemovedKeysSet
      console.log('[MasterTreeTransfer] onSelectAdd newRemovedKeysSet', newRemovedKeysSet)
      nextTick(() => {
        emit('change', 'addTreeData', addTreeData.value)
        emit('change', 'addSectionsData', addSectionsData.value)
      })
    }

    const onSelectRemove = ([selectedKey], { node }) => {
      console.log('[MasterTreeTransfer] onSelectRemove selectedKey', selectedKey, node)
      // const addSectionsMap = props.addSectionsData.reduce((acc, section) => {
      //   acc[section.sectionId] = section
      //   return acc
      // }, {})

      // const newAddSectionsData = [...props.addSectionsData]
      // newAddSectionsData.push(node.dataRef)

      // if (node.parentSectionId) {
      //   const parentSectionInAddSectionsData = addSectionsMap[node.parentSectionId]
      //   if (!parentSectionInAddSectionsData) {
      //     newAddSectionsData.push(node.parent.node.dataRef)
      //   }
      // } else if (node.treeChildren) {
      //   node.treeChildren.forEach((child) => {
      //     if (!addSectionsMap[child.sectionId]) newAddSectionsData.push(child)
      //   })
      // }

      // emit('update:addSectionsData', newAddSectionsData)
      if (!selectedKey) {
        selectedKey = node.key // eslint-disable-line no-param-reassign
        removeSelectedKeys.value = [node.key]
      }

      const newRemovedKeysSet = new Set(removedKeysSet.value)
      newRemovedKeysSet.delete(selectedKey)

      if (node.parent?.node?.treeChildren) {
        const { parent: { node: parentNode } } = node
        // parentNode.treeChildren 會隨著當前搜尋狀態 變化，所以需要使用 addTreeData.value 來取得 treeChildren
        const treeChildren = removeTreeData.value.find(d => d.sectionId === parentNode.sectionId)?.treeChildren || []
        const noOtherChildIsRemoved = treeChildren.every(({ sectionId }) => !newRemovedKeysSet.has(sectionId))
        console.log('onSelectRemove noOtherChildIsRemoved', noOtherChildIsRemoved)
        if (noOtherChildIsRemoved) {
          newRemovedKeysSet.delete(parentNode.sectionId)
          halfRemovedParentKeysSet.value.delete(parentNode.sectionId)
        } else {
          halfRemovedParentKeysSet.value.add(parentNode.sectionId)
        }
      }

      if (node.treeChildren) {
        node.treeChildren.forEach(c => newRemovedKeysSet.delete(c.sectionId))
        halfRemovedParentKeysSet.value.delete(selectedKey)
      }

      removedKeysSet.value = newRemovedKeysSet
      nextTick(() => {
        emit('change', 'addTreeData', addTreeData.value)
        emit('change', 'addSectionsData', addSectionsData.value)
      })
    }

    watch(
      () => derivedSectionsData.value.addSectionsData,
      (newAddSectionsData) => {
        const newAddSectionsIds = []
        const newAddSectionsDataWithMasterDocId = []

        newAddSectionsData.forEach((section) => {
          newAddSectionsIds.push(section.sectionId)
          newAddSectionsDataWithMasterDocId.push({
            ...section,
            docId: `${props.docData.wallet}#master`,
          })
        })

        newAddSectionsIds.sort()
        const hasAddSectionsDataChanged = !isEqual(addSectionsIds.value, newAddSectionsIds)

        console.log('hasAddSectionsDataChanged', {
          hasAddSectionsDataChanged,
          addSectionsIds: toRaw(addSectionsIds.value),
          newAddSectionsIds,
        })

        if (hasAddSectionsDataChanged) addSectionsData.value = newAddSectionsDataWithMasterDocId
        addExpandedKeys.value = addTreeData.value.map(({ sectionId }) => sectionId)

        // 新建 doc 時 sectionId 清單與初始值相同，仍須同步給父層 transferState
        if (!props.isNewDoc && !hasAddSectionsDataChanged) return

        emit('change', 'addTreeData', addTreeData.value)
        emit('change', 'addSectionsData', addSectionsData.value)
      },
      { immediate: true },
    )

    return {
      isDev,
      searchState,
      onSearch,
      noApiSection,
      shouldBeAddedSections,
      shouldBeRemovedSections,
      addTreeData,
      displayedAddTreeData,
      removeTreeData,
      displayedRemoveTreeData,
      addSelectedKeys,
      addExpandedKeys,
      removeSelectedKeys,
      removedKeys,
      halfRemovedParentKeysSet,
      filteredMasterSectionData,
      onSelectAdd,
      onSelectRemove,
      addSectionsIds,
      addSectionsDataBySectionId,
    }
  },
}
</script>

<style scoped>
:deep(.transfer-tree) {
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  height: 300px;
  overflow-y: auto;
}

.master-tree-transfer .ant-alert {
  margin-bottom: 16px;
  padding: 12px 16px;
}

:deep(.section-alert .ant-alert-icon) {
  align-self: flex-start;
  margin-top: 3px;
}

.section-list {
  margin-top: 6px;
  margin-bottom: 0;
  padding: 0 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.master-tree-transfer .icon {
  font-size: 20px;
  vertical-align: middle;
}

.master-tree-transfer .icon.added-sections-icon {
  color: #52c41a;
}

.master-tree-transfer .icon.removed-sections-icon {
  color: #ff4d4f;
}
</style>
